import { ItemFacet } from '@/types/ItemFacets';
import { MAX_CATEGORY_DEPTH } from '@/pages/Item/components/SimilarSoldItemsCarousel/constants/SimilarSoldItemsCarousel.constants';

export const getMostSpecificCategory = ([categories]: ItemFacet[]): {
    categoryId: number;
    categoryName: string;
    categoryUrl: string;
} => {
    for (let i = MAX_CATEGORY_DEPTH; i > 0; i--) {
        if (Boolean(categories[`l${i}CategoryId`])) {
            return {
                categoryId: categories[`l${i}CategoryId`],
                categoryName: categories[`l${i}CategoryName`],
                categoryUrl: categories[`l${i}CategoryUrl`],
            };
        }
    }
};
